import parsePhoneNumber from 'libphonenumber-js';

import countries from 'utils/countries.json';

export function getCountryObject(phone) {
  const parsedPhone = parsePhoneNumber(phone);
  if (parsedPhone) {
    return countries.find(
      (item) => item.dial_code === `+${parsedPhone.countryCallingCode}`
    );
  }
}
